import { Link } from "shared/components/Link";;
import { AppRoute } from "../../constants";
import RabbitMQClient from "../../images/systemComponents/RabbitMQClient.png";
import Layout from "../../components/Layout";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    RabbitMQ клиент
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        Использование <b>RabbitMQ клиента</b> в SCADA NPT Compact позволяет решать задачи, связанные с обменом сообщениями, интеграцией различных компонентов системы и обеспечением надежной передачи данных. RabbitMQ — это мощный и гибкий брокер сообщений, который поддерживает различные протоколы (включая AMQP, <Link className="text-links" to={`/${AppRoute.MQTTClient}`}>MQTT</Link>, STOMP) и предоставляет широкие возможности для управления очередями, маршрутизацией сообщений и обработкой данных.
                    </p>
                    <img
                        src={RabbitMQClient}
                        className="mb-4  w-100"
                        alt="RabbitMQ Клиент"
                    />

                    <p>Основные задачи, которые решает использование RabbitMQ клиента в SCADA NPT Compact, включают:</p>

                    <ul className="mb-4 description__list">

                        <li className="mb-1 description__number-li"><b>Организация обмена сообщениями между компонентами системы</b>
                            <ul>
                                <li>RabbitMQ обеспечивает надежную передачу сообщений между различными компонентами SCADA-системы, такими как:
                                    <ul>
                                        <li>Устройства (датчики, контроллеры).</li>
                                        <li>Серверы сбора данных.</li>
                                        <li>Базы данных.</li>
                                        <li>Пользовательские интерфейсы.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Обеспечение надежности и отказоустойчивости</b>
                            <ul>
                                <li>RabbitMQ поддерживает механизмы подтверждения доставки сообщений, что гарантирует их надежную передачу даже в условиях нестабильной сети.</li>
                                <li>Сообщения могут быть сохранены на диске, что предотвращает их потерю в случае сбоя системы.  </li>
                                <li>RabbitMQ поддерживает кластеризацию и репликацию данных, что обеспечивает высокую доступность системы даже в случае сбоя одного из узлов. </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Масштабируемость системы</b>
                            <ul>
                                <li>RabbitMQ позволяет легко масштабировать SCADA-систему, добавляя новые устройства или сервисы без изменения архитектуры.</li>
                                <li>Благодаря поддержке кластеризации RabbitMQ может работать в распределенных системах с высокой нагрузкой. </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Организация очередей сообщений</b>
                            <ul>
                                <li>RabbitMQ позволяет создавать очереди сообщений, что помогает управлять нагрузкой и обеспечивать порядок обработки данных. Очереди могут быть настроены для приоритетной обработки критически важных сообщений (например, аварийных сигналов).</li>
                                <li>RabbitMQ позволяет настраивать задержку доставки сообщений, что может быть полезно для реализации сценариев, требующих отложенной обработки данных.</li>
                                <li>RabbitMQ предоставляет инструменты для мониторинга состояния очередей, производительности и нагрузки на систему. Это позволяет администраторам своевременно выявлять и устранять проблемы.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Маршрутизация сообщений</b>
                            <ul>
                                <li>RabbitMQ поддерживает гибкие механизмы маршрутизации сообщений, такие как:
                                    <ul>
                                        <li>Точка-точка (point-to-point).</li>
                                        <li>Широковещательная рассылка (publish-subscribe).</li>
                                        <li>Маршрутизация на основе ключей (routing keys).</li>

                                    </ul>
                                </li>
                                <li>Это позволяет направлять сообщения только тем компонентам системы, которым они предназначены.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Обеспечение безопасности</b>
                            <ul>
                                <li>RabbitMQ поддерживает механизмы аутентификации, авторизации и шифрования (например, TLS/SSL), что обеспечивает защиту данных от несанкционированного доступа. Это особенно важно для SCADA-систем, работающих в критически важных отраслях.
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Интеграция разнородных систем</b>
                            <ul>
                                <li>RabbitMQ поддерживает множество протоколов (AMQP, MQTT, STOMP, HTTP и др.), что позволяет интегрировать SCADA-систему с различными устройствами и сторонними системами, такими как:
                                    <ul>
                                        <li>IoT-устройства.</li>
                                        <li>ERP-системы.</li>
                                        <li>Базы данных.</li>
                                        <li>Веб-приложения.</li>
                                    </ul>
                                </li>

                            </ul>
                        </li>
                    </ul>

                </div>

            </div>
        </div>
    </Layout>
}
